import { defineComponent as _defineComponent } from 'vue'
import PublicSaleInfo from "@/components/buyTokens/PublicSaleInfo.vue";
import InvestmentCalculator from "@/components/buyTokens/InvestmentCalculator.vue";
import {TokenReservation, usePublicSalesStore} from "@/store/publicSales.store";
import {computed, onBeforeMount, ref} from "vue";
import AllocationInfo from "@/components/transactions/AllocationInfo.vue";
import Dialog from "primevue/dialog";
import {useTransactionContextStore} from "@/store/transactionContext.store";
import { useUserServiceStore} from "@/store/userService.store";
import {useRouter} from "vue-router";
import {Currency} from "@/models/currency";
import {useToast} from "vue-toastification";
import ApprovalModal from "@/components/buyTokens/modals/ApprovalModal.vue";
import ProvideAddresInfoModal from "@/components/buyTokens/modals/ProvideAddresInfoModal.vue";
import {AddressType} from "@/components/buyTokens/modals/AddressType";
import {useUserStore} from "@/store/user.store";
import {useContextStore} from "@/store/context.store";
import BuyTokensModal from "@/components/buyTokens/modals/BuyTokensModal.vue";
import SynapsVerify from '@synaps-io/vue3-verify';
import LoginPopUp from "@/components/layout/loginPopup/LoginPopUp.vue";
import dataService from "@/services/data.service";
import OrderModal from "@/components/buyTokens/modals/OrderModal.vue";
import ConfirmDialogYesNo from "@/components/utils/ConfirmDialogYesNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoView',
  setup(__props, { expose: __expose }) {
  __expose();


onBeforeMount(() => {
  dataService.onInfoView();

});

const router = useRouter();
const toast = useToast();
const publicSaleStore = usePublicSalesStore();
const transactionContextStore = useTransactionContextStore();

const showAddressInfoModal = ref(false);
const showAddressInfoModalAddressType = ref(AddressType.KEPLR);

const kycModalVisible = ref(false);
const loginPopupStatus = ref(false);

const showApprovalModal = ref(false);
const confirmDialogYesNoRef = ref<typeof ConfirmDialogYesNo>();

const onKycStart = () => {
  useUserServiceStore().initKycSession(true).then(() => {
    kycModalVisible.value = true;
    // router.push({name: 'kyc'});
  });

};
const onCancelAllocation = (orderId: number) => {
  console.log('Cancel Allocation');
  confirmDialogYesNoRef.value?.confirmRequired(orderId);
};

const cancelAllocation = (orderId: number) => {
  usePublicSalesStore().cancelReservation(orderId, () => {
      usePublicSalesStore().fetchTokenReservations(false);
    }, () => {
    console.log('Error');});
};
const isLoggedIn = computed(() =>{
  return useUserStore().isLoggedIn;
});
function provideClaimerAddress(){
  if(!isLoggedIn.value) {
    loginPopupStatus.value = true;
  } else {
    onShowInfoModal(AddressType.KEPLR);
  }
}

const onShowInfoModal = (addressType: AddressType) => {
  showAddressInfoModalAddressType.value = addressType;
  showAddressInfoModal.value = true;
};
function provideSourceAddress(){
  if(useUserStore().metamaskConnectionInfo.address == '') {
    useUserStore().connectMetamask(() => {
      onShowInfoModal(AddressType.METAMASK);
    });
  } else {
    onShowInfoModal(AddressType.METAMASK);
  }
}
function hideApprovalModal(){
  showApprovalModal.value = false;
}
const c4eAddress = computed(() => {
  return useUserStore().getAccount.address;
});

const transactions = computed(() => {
  return usePublicSalesStore().getTransactions;
});
const showModal = ref<boolean>(false);
const selectedReservation = ref();

const sessionId = computed(() => {
  return useUserServiceStore().kycSessionId;
});

const onPay = (transaction: TokenReservation) => {
  selectedReservation.value = transaction;
  showModal.value = true;
};
const onBuyClick = () => {
  transactionContextStore.orderModalVisible = true;
};
const onPayReservation = () => {
  showModal.value = false;
  transactionContextStore.setOrderId(selectedReservation.value.orderId);
  if(transactionContextStore.paymentCurrency != Currency.STABLE) {
    router.push({name: 'fiatPaymentConfirmation'});
  } else {
    router.push({name: 'paymentConfirmation'});
  }
};
function showApprovalModalFunc(){
  showApprovalModal.value = true;
}

const onFail = () => {
  // let toastMessage = 'An error occurred \n';
  // if (errorMessage) toastMessage+=errorMessage;
  // toast.error(toastMessage);
};
const usersWallet = computed(() => {
  return useUserStore().getAccount.address;
});
function addressConfirmed(){
  showAddressInfoModal.value = false;
  if(showAddressInfoModalAddressType.value == AddressType.KEPLR) {
    console.log('Connect keplr account');
    if (usersWallet.value) {
      useUserServiceStore().initEmailKeplrPairing(useUserStore().getAccount.address, onSuccessConnect, onFail);
    } else {
      toast.error('You have to be logged in with Email');
    }
  }
  if(showAddressInfoModalAddressType.value == AddressType.METAMASK) {
    console.log('Connect metamask account');
    useUserServiceStore().initEmailMetamaskPairing(useUserStore().metamaskConnectionInfo.address, onSuccessConnect, onFail);
  }
}
const onSuccessConnect = () => {
  useContextStore().addressType = showAddressInfoModalAddressType.value;
  transactionContextStore.orderModalVisible = true;
  router.push({name: 'provideVerificationCode'});
};
function closeProvideAddressModalClose(){
  showAddressInfoModal.value = false;
}

const activeRound = computed(() => {
  if (publicSaleStore.roundInfo)
    return (new Date() < publicSaleStore.roundInfo?.endDate);
  else return false;
});


const __returned__ = { router, toast, publicSaleStore, transactionContextStore, showAddressInfoModal, showAddressInfoModalAddressType, kycModalVisible, loginPopupStatus, showApprovalModal, confirmDialogYesNoRef, onKycStart, onCancelAllocation, cancelAllocation, isLoggedIn, provideClaimerAddress, onShowInfoModal, provideSourceAddress, hideApprovalModal, c4eAddress, transactions, showModal, selectedReservation, sessionId, onPay, onBuyClick, onPayReservation, showApprovalModalFunc, onFail, usersWallet, addressConfirmed, onSuccessConnect, closeProvideAddressModalClose, activeRound, PublicSaleInfo, InvestmentCalculator, AllocationInfo, get Dialog() { return Dialog }, get useTransactionContextStore() { return useTransactionContextStore }, get useUserServiceStore() { return useUserServiceStore }, ApprovalModal, ProvideAddresInfoModal, get AddressType() { return AddressType }, get useUserStore() { return useUserStore }, BuyTokensModal, get SynapsVerify() { return SynapsVerify }, LoginPopUp, OrderModal, ConfirmDialogYesNo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})